import homeHeroGems from '../../assets/content/home-hero-gems.webp';
import homeHeroAnimation from '../../assets/content/home-hero-gems.mp4';
import categoryRingsBg from '../../assets/content/category-bg-rings.webp';
import categoryPendantsBg from '../../assets/content/category-bg-pendants.webp';
import categoryBraceletBg from '../../assets/content/category-bg-bracelet.webp';
import genderWomensJewelry from '../../assets/content/gender-womens-jewelry.webp';
import genderMensJewelry from '../../assets/content/gender-mens-jewelry.webp';

export const genderCollections = [
  {
    label: "Women's",
    title: "Women's Jewelry",
    description: 'Refined pieces for everyday and occasion styling.',
    href: '/products/gender/womens',
    backgroundImage: genderWomensJewelry,
  },
  {
    label: "Men's",
    title: "Men's Jewelry",
    description: 'Clean lines, structure, and polished metalwork.',
    href: '/products/gender/mens',
    backgroundImage: genderMensJewelry,
  },
];

export const fallbackProductTypes: Array<{ name: string; image?: { publicUrl: string } | null }> = [
  { name: 'Rings' },
  { name: 'Pendants' },
  { name: 'Bracelet' },
];

export const categoryBackgrounds: Record<string, string> = {
  rings: categoryRingsBg,
  pendants: categoryPendantsBg,
  bracelet: categoryBraceletBg,
  bracelets: categoryBraceletBg,
};

export const normalizeTypeName = (name: string) => name.trim().toLowerCase();

export { homeHeroAnimation, homeHeroGems };
